import React from 'react'

const CarouselTextContent = (): JSX.Element => {
  return (
    <div className='flex flex-col gap-4 text-justify font-roboto'>

    <div className='flex flex-col'>
      <h1 className='text-white'>PRIMER PASO:</h1>
      <p className='text-white'>TENER UNA CUENTA CON LA IDENTIDAD VALIDADA EN "MI ARGENTINA <a className='text-red-500' href="https://id.argentina.gob.ar/ingresar/"> <strong>AQUÍ</strong> </a></p>
    </div>
    <div className='flex flex-col'>
      <h1 className='text-white'>SI YA TENES TU CUENTA ACTIVA EN MI ARGENTINA, EMPEZAMOS CON EL REGISTRO DE LA PÁGINA DEL REPROCANN! <a href="https://reprocann.msal.gob.ar/auth" className='text-red-500'> <strong>AQUÍ</strong> </a></h1>
      
    </div>


    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>1</strong> TOCAR DONDE DICE "ACCEDER CON MI ARGENTINA".</p>

    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>2</strong> ELEGIR EL ROL DE "PACIENTE Y/O AUTOCULTIVADOR".</p>

    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>3</strong> COMPLETAR TODOS LOS DATOS PERSONALES QUE TE PIDE
(LA DIRECCIÓN QUE PIDE ES LA DIRECCION DONDE VAS A TENER EL CULTIVO, PUEDE SER O NO LA DIRECCION QUE TE FIGURA EN TU DNI!)
</p>

    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>4</strong> SELECCIONAR LA OBRA SOCIAL QUE APARECE AHI. (LA PÁGINA TIENE UN ERROR EL CUAL NO TE DEJA SELECCIONAR OTRA)</p>

    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>5</strong> EN TIPO DE CULTIVO SELECCIONAR "AUTOCULTIVO"</p>

    <p className='text-sm text-white'><strong className='p-1 px-2 rounded-full bg-green-600 text-white'>6</strong> EN CAPACIDAD DE CULTIVO COLOCAR "9"</p>

    <p className='text-sm text-white'>LISTO! YA ESTÁS REGISTRADX EN LA PLATAFORMA DEL REPROCANN. 
</p>

    <div className='text-white'>
        <p>PARA VISUALIZAR TU CÓDIGO DE VINCULACIÓN:</p>
        <p>1. INGRESAR NUEVAMENTE A LA PAGINA DEL REPROCANN: <a href="https://reprocann.msal.gob.ar/auth" className='text-red-500'> <strong>AQUÍ</strong> </a></p>  
        <p>2. TOCAR DONDE DICE "ACCEDER CON MI ARGENTINA"</p>  
        <p>3. TOCAR EL ROL DE "PACIENTE Y/O AUTOCULTIVADOR" </p>  
        <p>4. TOCAR DONDE DICE "MIS DATOS"</p>  
    </div>         
  </div>
  )
}

export default CarouselTextContent